import { MutationTree } from 'vuex';

import {
  FilesStateI,
} from './state';

export const mutations: MutationTree<FilesStateI> = {
};
